import { all, call } from "@redux-saga/core/effects";
import { checkLoginSagas } from "./modules/auth/checkLogin";
import { getOtpCodeSagas } from "./modules/auth/getOtpCode";
import { verifyOtpSagas } from "./modules/auth/verifyOtp";
import { getCategoryListSagas } from "./modules/ai/getCategoryList/getCategoryList";
import { getCategoryServicesSagas } from "./modules/ai/getCategoryServices/getCategoryServices";
import { getServiceSegmentsSagas } from "./modules/ai/getServiceSegments/getServiceSegments";
import { getServicePurchaseModelsSagas } from "./modules/ai/getServicePurchaseModels/getServicePurchaseModels";
import { serviceFileValidationSagas } from "./modules/ai/serviceFileValidation/serviceFileValidation";
import { getUserSubServicesSagas } from "./modules/ai/getUserSubServices/getUserSubServices";
import { getUserChatsSagas } from "./modules/ai/getUserChats/getUserChats";
import { choosePurchaseModelSagas } from "./modules/ai/choosePurchaseModel/choosePurchaseModel";
import { postUserServiceChatSagas } from "./modules/ai/postUserServiceChat/postUserServiceChat";
import { postUserServiceEntrySagas } from "./modules/ai/postUserServiceEntry/postUserServiceEntry";
import { buySubServiceSagas } from "./modules/ai/buySubService/buySubService";
import { postUserUploadFileSagas } from "./modules/ai/postUserUploadFile/postUserUploadFile";
import { getResultModalDataSagas } from "./modules/ai/getResultModalData/getResultModalData";
import { shareSagas } from "./modules/ai/share/share";
import { createUserServiceSagas } from "./modules/ai/postCreateUserService/postCreateUserService";
import { specialistProfileSagas } from "./modules/specialistProfile/specialistProfile";
import { getSubscriptionPlansSagas } from "./modules/ai/getSubscriptionPlans/getSubscriptionPlans";
import { buySubscriptionPlanSagas } from "./modules/ai/buySubscriptionPlan/buySubscriptionPlan";
import { getUserHistorySagas } from "./modules/ai/getUserHistory/getUserHistory";
import { thirdPartyCreateUserServiceSagas } from "./modules/ai/postThirdPartyCreateUserService/postThirdPartyCreateUserService";
import { postThirdPartyUserServiceChatSagas } from "./modules/ai/postThirdPartyUserServiceChat/postThirdPartyUserServiceChat";
import { buySubServicesSagas } from "./modules/ai/buySubServices/buySubServices";
import { getThirdPartyUserSubServicesHistorySagas } from "./modules/ai/getThirdPartyUserSubServicesHistory/getThirdPartyUserSubServicesHistory";
import { getThirdPartyChatsSagas } from "./modules/ai/getThirdPartyChats/getThirdPartyChats";
import { checkDiscountSagas } from "./modules/ai/checkDiscount/checkDiscount";
import { deleteUserSubServiceSagas } from "./modules/ai/deleteUserSubService/deleteUserSubService";
import { userSubServiceFilesSagas } from "./modules/ai/postUserSubServiceFiles/postUserSubServiceFiles";
import { getProfileSagas } from "./modules/ai/getProfile/getProfile";
import { profileUpdateSagas } from "./modules/ai/profileUpdate/profileUpdate";
import { userLogoutSagas } from "./modules/ai/userLogout/userLogout";
import { deleteUserSessionFilesSagas } from "./modules/ai/deleteUserSessionFiles/deleteUserSessionFiles";
import { getUserTransactionsSagas } from "./modules/ai/getUserTransactions/getUserTransactions";
import { walletCashInSagas } from "./modules/ai/walletCashIn/walletCashIn";
import { getUserNotificationsSagas } from "./modules/ai/getUserNotifications/getUserNotifications";
import { seenAnnouncedNotificationSagas } from "./modules/ai/postSeenAnnouncedNotification/postSeenAnnouncedNotification";
import { authGoogleSagas } from "./modules/auth/authGoogle";
import { authGoogleCredentialSagas } from "./modules/auth/authGoogleCredential";
import { fcmTokenSagas } from "./modules/fcmToken/fcmToken";
import { getTokensMultiplierRatioSagas } from "./modules/ai/getTokensMultiplierRatio/getTokensMultiplierRatio";
import { getUserPersonalizationSagas } from "./modules/ai/getUserPersonalization/getUserPersonalization";
import { postUserPersonalizationSagas } from "./modules/ai/postUserPersonalization/postUserPersonalization";
import { getExtraTokenShowSagas } from "./modules/ai/getExtraTokenShow/getExtraTokenShow";
import { postExtraTokenShowSagas } from "./modules/ai/postExtraTokenShow/postExtraTokenShow";
import { getUserTokenHistorySagas } from "./modules/ai/getUserTokenHistory/getUserTokenHistory";
import { getSubscriptionHistorySagas } from "./modules/ai/getSubscriptionHistory/getSubscriptionHistory";
import { getAnnouncedNotificationsSagas } from "./modules/ai/announcedNotifications/announcedNotifications";
import { postReferralCodeSagas } from "./modules/ai/postReferralCode/postReferralCode";
import {getClientIdentifiersSagas} from "./modules/getClientIdentifiers/getClientIdentifiers";
import {getTextToSpeechSagas} from "./modules/ai/getTextToSpeech/getTextToSpeech";
import {postFeedbackSagas} from "./modules/ai/postFeedback/postFeedback";
import {getFeedbacksSagas} from "./modules/ai/getFeedbacks/getFeedbacks";
import {showBotsSagas} from "./modules/bots/showBots/showBots";
import {agencyCreateUserServiceSagas} from "./modules/bots/postAgencyCreateUserService/postAgencyCreateUserService";
import {agencyListSagas} from "./modules/bots/agencyList/agencyList";
import {createAgencySagas} from "./modules/bots/createAgency/createAgency";
import {checkAgencyUsernameSagas} from "./modules/bots/checkAgencyUsername/checkAgencyUsername";
import {createRealtimeSessionSagas} from "./modules/ai/createRealtimeSession/createRealtimeSession";
import {getRealTimeChatSagas} from "./modules/ai/getRealTimeChat/getRealTimeChat";
import { updateAgencySagas } from "./modules/bots/updateAgency/updateAgency";
import { updateAvatarSagas } from "./modules/bots/updateAvatar/updateAvatar";
import { agencyRawDataListSagas } from "./modules/bots/agencyRawDataList/agencyRawDataList";
import { agencyRawDataStoreSagas } from "./modules/bots/agencyRawDataStore/agencyRawDataStore";
import { agencyRawDataDeleteSagas } from "./modules/bots/agencyRawDataDelete/agencyRawDataDelete";

export function* rootSaga() {
  yield all([
    call(checkLoginSagas),
    call(getOtpCodeSagas),
    call(verifyOtpSagas),
    call(getCategoryListSagas),
    call(getCategoryServicesSagas),
    call(getServiceSegmentsSagas),
    call(getServicePurchaseModelsSagas),
    call(serviceFileValidationSagas),
    call(getUserSubServicesSagas),
    call(getUserChatsSagas),
    call(choosePurchaseModelSagas),
    call(postUserServiceChatSagas),
    call(postUserServiceEntrySagas),
    call(buySubServiceSagas),
    call(postUserUploadFileSagas),
    call(getResultModalDataSagas),
    call(shareSagas),
    call(createUserServiceSagas),
    call(getSubscriptionPlansSagas),
    call(buySubscriptionPlanSagas),
    call(specialistProfileSagas),
    call(getUserHistorySagas),
    call(buySubServicesSagas),
    call(thirdPartyCreateUserServiceSagas),
    call(postThirdPartyUserServiceChatSagas),
    call(getThirdPartyUserSubServicesHistorySagas),
    call(getThirdPartyChatsSagas),
    call(checkDiscountSagas),
    call(deleteUserSubServiceSagas),
    call(userSubServiceFilesSagas),
    call(getProfileSagas),
    call(profileUpdateSagas),
    call(userLogoutSagas),
    call(deleteUserSessionFilesSagas),
    call(getUserTransactionsSagas),
    call(walletCashInSagas),
    call(getUserNotificationsSagas),
    call(seenAnnouncedNotificationSagas),
    call(authGoogleSagas),
    call(authGoogleCredentialSagas),
    call(fcmTokenSagas),
    call(getTokensMultiplierRatioSagas),
    call(getUserPersonalizationSagas),
    call(postUserPersonalizationSagas),
    call(getExtraTokenShowSagas),
    call(postExtraTokenShowSagas),
    call(getUserTokenHistorySagas),
    call(getSubscriptionHistorySagas),
    call(getAnnouncedNotificationsSagas),
    call(postReferralCodeSagas),
    call(getClientIdentifiersSagas),
    call(getTextToSpeechSagas),
    call(postFeedbackSagas),
    call(getFeedbacksSagas),
    call(showBotsSagas),
    call(agencyCreateUserServiceSagas),
    call(agencyListSagas),
    call(createAgencySagas),
    call(checkAgencyUsernameSagas),
    call(createRealtimeSessionSagas),
    call(getRealTimeChatSagas),
    call(updateAgencySagas),
    call(updateAvatarSagas),
    call(agencyRawDataListSagas),
    call(agencyRawDataStoreSagas),
    call(agencyRawDataDeleteSagas),
  ]);
}
